import { render, staticRenderFns } from "./GED.vue?vue&type=template&id=48e9f3de&scoped=true"
import script from "./GED.vue?vue&type=script&lang=js"
export * from "./GED.vue?vue&type=script&lang=js"
import style0 from "./GED.vue?vue&type=style&index=0&id=48e9f3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9f3de",
  null
  
)

export default component.exports